var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var buildSeriesData = function buildSeriesData(dataArr, categoryName, yValueKey, crumbKey, crumbDisplayKey, limit, formatConfig, seriesConfig) {
    if (formatConfig && formatConfig.length > 0) {
        formatConfig.reverse();
    }

    var data = dataArr.map(function (obj) {
        var color = void 0,
            borderColor = void 0,
            value = void 0;
        if (formatConfig && formatConfig.length > 0) {
            formatConfig.forEach(function (config) {
                var FormatOption = config.FormatOption,
                    FormatRule = config.FormatRule,
                    FormatValue = config.FormatValue,
                    TableField = config.TableField,
                    TargetProperty = config.TargetProperty;

                var compare = void 0;

                switch (FormatRule) {
                    case 'GreaterThan':
                        compare = function compare(a, b) {
                            return Number(a) > Number(b);
                        };
                        break;
                    case 'LessThan':
                        compare = function compare(a, b) {
                            return Number(a) < Number(b);
                        };
                        break;
                    case 'EqualTo':
                        compare = function compare(a, b) {
                            return String(a).toLowerCase() == String(b).toLowerCase();
                        };
                        break;
                    case 'NotEqualTo':
                        compare = function compare(a, b) {
                            return String(a).toLowerCase() != String(b).toLowerCase();
                        };
                        break;
                    case 'LessThanorEqualTo':
                        compare = function compare(a, b) {
                            return Number(a) <= Number(b);
                        };
                        break;
                    case 'GreaterThanorEqualTo':
                        compare = function compare(a, b) {
                            return Number(a) >= Number(b);
                        };
                        break;
                    case 'Contains':
                        compare = function compare(a, b) {
                            return String(a).toLowerCase().includes(String(b).toLowerCase());
                        };
                        break;
                    case 'StartsWith':
                        compare = function compare(a, b) {
                            return String(a).toLowerCase().startsWith(String(b).toLowerCase());
                        };
                        break;
                    case 'EndsWith':
                        compare = function compare(a, b) {
                            return String(a).toLowerCase().endsWith(String(b).toLowerCase());
                        };
                        break;
                    default:
                        compare = function compare() {
                            return false;
                        };
                }
                var compareField = TableField ? TableField : yValueKey;
                var compareValue = TargetProperty ? obj[TargetProperty] : FormatValue;
                var shouldFormat = compare(obj[compareField], compareValue);
                if (shouldFormat && FormatOption && FormatOption[0]) {
                    color = FormatOption[0].Fill;
                    borderColor = FormatOption[0].BorderColor;
                }
            });
        }

        !obj.counter && obj.RecordCount ? obj.counter = obj.RecordCount : null;

        var xValueKey = seriesConfig.XValueField;
        var zValueKey = seriesConfig.FieldName;
        var ignoreBlanks = seriesConfig.IgnoreBlanks;
        yValueKey = seriesConfig.SeriesType == 'bubble' ? seriesConfig.YValueField : yValueKey;
        var ignoreBlanksValue = ignoreBlanks ? null : 0;

        if (['pie', 'doughnut'].includes(seriesConfig.SeriesType.toLowerCase())) {
            value = Math.abs(obj[yValueKey]);
        } else value = obj[yValueKey] ? obj[yValueKey] / 1 : ignoreBlanksValue;

        return _extends({
            name: obj[categoryName],
            y: value,
            x: obj[xValueKey],
            z: obj[zValueKey],
            value: value,
            crumbValue: obj[crumbKey],
            crumbDisplay: obj[crumbDisplayKey],
            color: color,
            borderColor: borderColor,
            borderWidth: borderColor ? 1 : undefined
        }, obj, obj.tooltip, {
            low: obj.Min,
            q1: obj.LowPercentile,
            median: obj.Median,
            q3: obj.HighPercentile,
            high: obj.Max,
            className: obj[yValueKey] < 0 ? 'negative-value' : undefined
        });
    });

    limit = parseInt(limit);
    if (limit) return data.slice(0, limit);
    return data;
};

export default buildSeriesData;